import ownerProjectsComponent from './owner-projects.component';

const ownerProjectsModule = angular.module('ownerProjects', [
])
  .component('ownerProjects', ownerProjectsComponent)
  .name;

export default ownerProjectsModule;
